import { NgModule } from '@angular/core';
import { F8TimePipe } from './f8-time.pipe';



export class F8TimePipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [F8TimePipe],
  exports: [F8TimePipe]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
